<template>
  <!-- 设备管理 -->
  <a-card :bordered="false">
    <a-form layout="inline">
      <div style="margin-bottom: 12px">
        <a-form-item label="泵房名称">
          <a-input v-model="query.pumpName" placeholder="请输入泵房名称" allow-clear/>
        </a-form-item>
        <a-form-item label="设备名称">
          <a-input v-model="query.deviceName" placeholder="请输入设备名称" allow-clear/>
        </a-form-item>
        <a-form-item label="设备编号">
          <a-input v-model="query.deviceNo" placeholder="请输入设备编号" allow-clear/>
        </a-form-item>
        <a-form-item label="设备状态">
          <a-select placeholder="请选择" default-value v-model="query.deviceStatus" style="width: 200px" allow-clear>
            <a-select-option :value="0">正常</a-select-option>
            <a-select-option :value="1">异常</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="设备类型 ">
          <a-select placeholder="请选择" default-value v-model="query.deviceType" style="width: 200px" allow-clear>
            <a-select-option value="加压设备">加压设备</a-select-option>
            <a-select-option value="加药设备">加药设备</a-select-option>
            <a-select-option value="其他设备">其他设备</a-select-option>
            >
          </a-select>
        </a-form-item>
      </div>
      <div style="margin-bottom: 12px">
        <a-form-item style="margin-left: 12px">
          <a-button type="primary" @click="queryList">查询</a-button>
          <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
          <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button>
          <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
        </a-form-item>
      </div>
    </a-form>

    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag :color="text == 1 ? 'rgb(255, 99, 71)' : 'rgb(50, 205, 50)'" slot="deviceStatus" slot-scope="text">
        {{ text === 0 ? '正常' : text === 1 ? '异常' : '' }}
      </a-tag>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
      </span>
    </a-table>
    <!-- 新增 修改 的弹框 -->
    <a-modal
      :title="this.titih"
      style="top: 20px"
      :width="800"
      :visible="addOrUpdateVisible"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="选择泵房绑定">
          <a-select
            v-decorator="['pumpId', { rules: [{ required: true, message: '请选择一个泵房绑定!' }] }]"
            placeholder="选择一个泵房绑定"
          >
            <a-select-option v-for="(item, index) in userlist" :key="index" :value="item.key">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备名称" hasFeedback>
          <a-input
            placeholder="设备名称"
            v-decorator="['deviceName', { rules: [{ required: true, message: '请输入设备名称' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备编号" hasFeedback>
          <a-input
            placeholder="设备编号"
            :disabled="disabled"
            v-decorator="['deviceNo', { rules: [{ required: true, message: '请输入设备编号' }] }]"
          />
        </a-form-item>
        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水厂名称" hasFeedback>
          <a-input
            placeholder="水厂名称"
            v-decorator="['waterWorksName', { rules: [{ required: true, message: '请输入水厂名称' }] }]"
          />
        </a-form-item> -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备状态">
          <a-radio-group
            placeholder="请选择"
            v-decorator="['deviceStatus', { rules: [{ required: true, message: '请选择设备状态' }] }]"
          >
            <a-radio :value="0">正常</a-radio>
            <a-radio :value="1">异常</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型">
          <a-radio-group v-decorator="['deviceType', { rules: [{ required: true, message: '请输入设备类型' }] }]">
            <a-radio value="加压设备">加压设备</a-radio>
            <a-radio value="加药设备">加药设备</a-radio>
            <a-radio value="其他设备">其他设备</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    align: 'center',
    title: '泵房名称',
    dataIndex: 'pumpName',
  },
  {
    align: 'center',
    title: '设备名称',
    dataIndex: 'deviceName',
  },
  {
    align: 'center',
    title: '设备编号',
    dataIndex: 'deviceNo',
  },
  // {
  //   align: 'center',
  //   title: '水厂名称',
  //   dataIndex: 'waterWorksName',
  // },
  {
    align: 'center',
    title: '设备类型',
    dataIndex: 'deviceType',
  },
  {
    align: 'center',
    title: '设备状态',
    dataIndex: 'deviceStatus',
    scopedSlots: {customRender: 'deviceStatus'},
  },
  {
    title: '操作',
    width: '150px',
    fixed: 'right',
    align: 'center',
    dataIndex: 'action',
    scopedSlots: {customRender: 'action'},
  },
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'task',
  data() {
    return {
      queryUrl: '/pipe-network/water_works_devices/page', //列表请求数据接口
      addOrUpdateUrl: '/pipe-network/water_works_devices', //新增
      queryOneUrl: '/pipe-network/water_works_devices/', //查询单条地址
      deleteUrl: '/pipe-network/water_works_devices', //删除
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      disabled:false,
      query: {
        deviceName: '',
        deviceNo: '',
        deviceStatus: '',
        deviceType: '',
        pumpName: '',
        sysType: 5,
      }, // 查询参数
      addOrUpdateVisible: false, // 新增修改是否可见
      // 分页条
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      addOrUpdateForm: this.$form.createForm(this, {name: 'addOrUpdate'}), //新增 修改
      titih: '新增',
      userlist: [],
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      columns,
    }
  },
  created() {
    this.queryList()
    this.getUserList()
  },
  methods: {
    // 根据id 修改
    addOrUpdateHandle(id) {
      if (id == undefined) {
        this.titih = '新增'
        this.disabled = false
      } else {
        this.titih = '编辑'
           this.disabled = true
      }

      this.addOrUpdateVisible = true
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({data}) => {
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => {
          })
      }
    },
    handleSelectChange(value) {
      let uerinfo = JSON.parse(value)
      ;(this.userId = uerinfo.key), (this.userName = uerinfo.title)
      this.addOrUpdateForm.setFieldsValue({name: uerinfo.name})
      // this.form.setFieldsValue(value);
    },
    getUserList() {
      this.$http.get('/pipe-network/twice_water_pumps/list').then(({data}) => {
        
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.pumpName + ' (' + item.pumpNo + ')',
            key: item.id,
            name: item.pumpNo,
          })
        })
        this.userlist = list
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
// .tenant-form {
//   /deep/ .permission-group {
//     margin-top: 0;
//     margin-bottom: 0;
//   }
// }
</style>
